// extracted by mini-css-extract-plugin
module.exports = {"buyButtonBlock":"BuyButtonBlock_buyButtonBlock__lgG7Q"};